module.exports = {
  "country": "GE",
  "artist": "Iru",
  "song": "Echo",
  "year": "2023",
  "place": "NQ",
  "spotify": "6Dw7BShqIiGPq69VEQ2hpd"
};